const REPORT_ABUSE_BASE_URL =
	'https://support.atlassian.com/contact/#/?inquiry_category=abuse&support_type=customer';

export type ReportAbuseUrlParams = {
	/** Atlassian Type Identifier, e.g. "ati:cloud:confluence:page" */
	ati?: string | null;
	/** Atlassian Resource Identifier, e.g. "ari:cloud:confluence::content/abc123" */
	ari?: string | null;
	/** URL of the content being reported */
	fileUrl?: string | null;
	/** Atlassian Account ID of the user submitting the report */
	reporteraaid?: string | null;
};

/**
 * Builds the full report-abuse URL by appending the four context query
 * parameters (ati, ari, reporteraaid, fileUrl) to the Atlassian Support
 * contact form base URL. Any parameter that is null / undefined / empty is
 * omitted so the resulting URL stays clean.
 */
export const buildReportAbuseUrl = ({
	ati,
	ari,
	fileUrl,
	reporteraaid,
}: ReportAbuseUrlParams): string => {
	const params = new URLSearchParams();
	if (ati) params.append('ati', ati);
	if (ari) params.append('ari', ari);
	if (reporteraaid) params.append('reporteraaid', reporteraaid);
	if (fileUrl) params.append('fileUrl', fileUrl);
	const extraParams = params.toString();
	return extraParams ? `${REPORT_ABUSE_BASE_URL}&${extraParams}` : REPORT_ABUSE_BASE_URL;
};
